module.exports = __webpack_public_path__ + "static/media/39.08177221.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/39.png
// module id = 407
// module chunks = 0